<main>
  @if (!loginService.isLoggedIn() &&
  !isAuthCallback() &&
  !isLogoutRoute()) {
  <app-login></app-login>
  } @else if (isAuthCallback() || isMediaInputRoute() || isLogoutRoute()) {
  <router-outlet></router-outlet>
  } @else {
  <app-side-nav>
    <router-outlet></router-outlet>
  </app-side-nav>
  }

  <!-- loading indicator for pending http requests -->
  <app-request-loading-indicator></app-request-loading-indicator>
</main>